'use strict';

var _regeneratorRuntime = require("/home/jenkins/workspace/buch-editor-frontend_master-HFHSIVOQ6IJI5ZBPHCHU7A6EKU7FAGJSAKF6XQUXPUJGATAUMFRQ/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _callee;

var _dependencies = require('../../dependencies');

var _actions = require('../actions');

var _actionTypes = require('../actionTypes');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _utilities = require('../utilities');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(retreiveLocaleFromLocaleStorage),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(_callee);

var takeEvery = _dependencies.sagaEffects.takeEvery,
    all = _dependencies.sagaEffects.all,
    put = _dependencies.sagaEffects.put;

function saveLocaleToLocalStorage(action) {
  var locale = action.locale;

  _utilities.LocalStorageHandlers.saveLocale(locale);
}

function retreiveLocaleFromLocaleStorage() {
  var locale;
  return _regeneratorRuntime.wrap(function retreiveLocaleFromLocaleStorage$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          locale = _utilities.LocalStorageHandlers.loadLocale();

          if (!locale) {
            _context.next = 4;
            break;
          }

          _context.next = 4;
          return put((0, _actions.setLocale)(locale));

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return all([takeEvery(_actionTypes2.default.SET_LOCALE, saveLocaleToLocalStorage), retreiveLocaleFromLocaleStorage()]);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}